import html2canvas from 'html2canvas';

export interface ChartCapture {
  name: string;
  dataUrl: string;
  width: number;
  height: number;
}

export interface ChartRefs {
  costSavingsAnalytics?: HTMLDivElement | null;
  costSavingsTrend?: HTMLDivElement | null;
  costSavingsComparison?: HTMLDivElement | null;
  costSavingsForecast?: HTMLDivElement | null;
  costSavingsGoals?: HTMLDivElement | null;
  agencyComparison?: HTMLDivElement | null;
  cumulativeBillableHours?: HTMLDivElement | null;
  careUtilizationMix?: HTMLDivElement | null;
}

export async function captureCharts(refs: ChartRefs): Promise<ChartCapture[]> {
  const captures: ChartCapture[] = [];

  const captureElement = async (element: HTMLDivElement | null | undefined, name: string): Promise<void> => {
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        backgroundColor: '#ffffff',
        scale: 2, // Higher quality
        logging: false,
        useCORS: true,
        allowTaint: true,
      });

      captures.push({
        name,
        dataUrl: canvas.toDataURL('image/png'),
        width: canvas.width,
        height: canvas.height,
      });
    } catch (error) {
      console.error(`Error capturing ${name}:`, error);
    }
  };

  // Capture all chart elements in parallel
  await Promise.all([
    captureElement(refs.costSavingsAnalytics, 'Billing Analytics'),
    captureElement(refs.costSavingsTrend, 'Cost Savings Trend'),
    captureElement(refs.costSavingsComparison, 'Period Comparison'),
    captureElement(refs.costSavingsForecast, 'Savings Forecast'),
    captureElement(refs.costSavingsGoals, 'Savings Goals'),
    captureElement(refs.agencyComparison, 'Agency Comparison'),
    captureElement(refs.cumulativeBillableHours, 'Cumulative Billable Hours Saved'),
    captureElement(refs.careUtilizationMix, 'Care Utilization Mix by Agency'),
  ]);

  return captures;
}
